import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';

export class HomePageActivityModel {
    public id: number;
    public mode: Activity.Mode;
    public name: string;
    public cover: string;
    public join_count: number;
    public rule_url: string;
    public monitor_apply_start_date: string;
    public monitor_apply_finish_date: string;
    public sign_up_start_date: string;
    public sign_up_finish_date: string;
    public sign_in_start_date: string;
    public sign_in_finish_date: string;

    public constructor(raw: HomePage.Activity) {
        this.id = raw.id;
        this.mode = raw.mode;
        this.name = raw.name;
        this.cover = raw.cover;
        this.join_count = raw.join_count;
        this.rule_url = raw.rule_url;
        this.monitor_apply_start_date = raw.monitor_apply_start_date;
        this.monitor_apply_finish_date = raw.monitor_apply_finish_date;
        this.sign_up_start_date = raw.sign_up_start_date;
        this.sign_up_finish_date = raw.sign_up_finish_date;
        this.sign_in_start_date = raw.sign_in_start_date;
        this.sign_in_finish_date = raw.sign_in_finish_date;
    }

    public get closeParticipation() {
        const serverDate = serverDateNow().valueOf();
        if(this.sign_up_finish_date) {
            return serverDate >= dateOffset(dateParse(this.sign_up_finish_date), 1)?.valueOf();
        }
    }

    public get startParticipation() {
        const serverDate = serverDateNow().valueOf();
        if(this.sign_up_start_date) {
            return serverDate >= dateParse(this.sign_up_start_date)?.valueOf();
        }
    }

    public get closeSignin() {
        const serverDate = serverDateNow().valueOf();
        if(this.sign_in_finish_date) {
            return serverDate >= dateOffset(dateParse(this.sign_in_finish_date), 1)?.valueOf();
        }
    }

    public get status() {
        return !this.closeParticipation ? (this.startParticipation ? '报名中' : '未开始') : (this.closeSignin ? '已结束' : '进行中');
    }
}
